module.exports = __webpack_public_path__ + "static/media/tagAdd.217bbc07.svg";